import { render, staticRenderFns } from "./SalesTasksPage.vue?vue&type=template&id=0751b4f8&scoped=true&"
import script from "./SalesTasksPage.vue?vue&type=script&lang=js&"
export * from "./SalesTasksPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesTasksPage.vue?vue&type=style&index=0&id=0751b4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0751b4f8",
  null
  
)

export default component.exports